import React from 'react';
import TdcBrandsLogo from '../../asset/image/tdc-brands.svg';

export default function BrandLogo() {
    return <img className="tdc-brands-logo" src={TdcBrandsLogo} alt="TDC Brands"/>;
}
